import {LegacyRef} from "react";
import {TextEditingButtons} from "./components";
import {Stack, useTheme} from "@mui/material";
import pxToRem from "hooks/usePxToRem";

type EmailPreviewProps = {
  emailContent: string;
  editorRef: LegacyRef<HTMLDivElement>;
  disabled?: boolean;
};

const EmailPreview = (props: EmailPreviewProps) => {
  const {emailContent, editorRef, disabled = false} = props;

  const theme = useTheme();

  return (
    <Stack
      direction="row"
      justifyContent={"space-between"}
      sx={{height: "100%", width: "100%"}}
    >
      <Stack
        alignItems={"center"}
        sx={{
          height: "100%",
          width: "100%",
          overflow: "auto",
          borderRadius: pxToRem(2),
          background:
            theme.palette.mode === "dark"
              ? theme.palette.text.primary
              : theme.palette.background.paper,
        }}
      >
        <div
          style={{height: "auto", width: "auto"}}
          contentEditable={!disabled}
          dangerouslySetInnerHTML={{
            __html: emailContent,
          }}
          ref={editorRef as LegacyRef<HTMLDivElement> | undefined}
        />
      </Stack>
      <TextEditingButtons />
    </Stack>
  );
};

export default EmailPreview;
